import { defaultHttpClient } from '../../../httpClient';
import type { ValidateAuthCodeResponse } from './types';

export interface ValidateAuthCodeParams {
  auth_code: string;
  public_code: string;
}

export const validateAuthCode = async (
  params: ValidateAuthCodeParams,
): Promise<ValidateAuthCodeResponse> => {
  const response = await defaultHttpClient.request<ValidateAuthCodeResponse>({
    method: 'POST',
    url: '/api/v2/verification_code/poc/verify/',
    data: params,
  });
  return response.data;
};
